"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildRegistrationUrl = exports.buildSignInUrl = exports.redirectToAuthPortalV2 = exports.getAuthPortalUrlV2 = exports.getMarketplaceOpenidAssocHandleV2 = exports.AuthHeadersEnum = void 0;
const config_1 = __importDefault(require("next/config"));
const constants_1 = require("../../constants");
const server_1 = require("../server");
const window_1 = require("../window");
var AuthHeadersEnum;
(function (AuthHeadersEnum) {
    AuthHeadersEnum["AntiCsrfToken"] = "anti-csrftoken-a2z";
})(AuthHeadersEnum = exports.AuthHeadersEnum || (exports.AuthHeadersEnum = {}));
const getMarketplaceOpenidAssocHandleV2 = (countryCode) => {
    return countryCode ? (countryCode === 'gb' ? 'amzn_launchpad_uk' : 'amzn_launchpad_' + countryCode) : '';
};
exports.getMarketplaceOpenidAssocHandleV2 = getMarketplaceOpenidAssocHandleV2;
function getAuthPortalUrlV2(amazonUrl, countryCode, forceRedirect, tenant, currentHref) {
    const returnUrl = currentHref !== null && currentHref !== void 0 ? currentHref : document.location.href;
    const SIGN_IN_PATH = '/ap/signin';
    const param = {
        amazonUrl,
        returnUrl,
        countryCode,
        tenant
    };
    const additionalParams = {};
    additionalParams['hz-migration'] = '1';
    additionalParams[constants_1.OPENID_NS_PAPE_PARAM] = constants_1.OPENID_NS_EXTENSION;
    if (forceRedirect) {
        additionalParams[constants_1.OPENID_MAX_AUTH_AGE_PARAM] = '0';
    }
    return buildAuthPortalUrl(param, SIGN_IN_PATH, additionalParams).toString();
}
exports.getAuthPortalUrlV2 = getAuthPortalUrlV2;
const redirectToAuthPortalV2 = (countryCode, forceRedirect, tenant) => {
    const { publicRuntimeConfig } = (0, config_1.default)();
    let amazonUrl = publicRuntimeConfig.amazonUrl;
    if (amazonUrl == null || amazonUrl.trim() === '') {
        amazonUrl = window.location.origin;
    }
    const authPortalUrl = getAuthPortalUrlV2(amazonUrl, countryCode, forceRedirect, tenant);
    window.location.href = authPortalUrl;
};
exports.redirectToAuthPortalV2 = redirectToAuthPortalV2;
const buildAuthPortalUrl = (params, pagePath, additionalParameters) => {
    const retailDomain = params.amazonUrl;
    const marketplaceOpenidAssocHandle = (0, exports.getMarketplaceOpenidAssocHandleV2)(params.countryCode);
    const returnUrl = params.returnUrl;
    const tenant = params.tenant
        ? params.tenant
        : (0, window_1.isClientSide)() && window.moneraTenant
            ? window.moneraTenant
            : 'UNKNOWN';
    const commonAuthPortalParams = {
        [constants_1.OPENID_MODE_PARAM]: constants_1.OPENID_MODE,
        [constants_1.OPENID_NS_PARAM]: constants_1.OPENID_NS,
        [constants_1.OPENID_RETURN_TO_PARAM]: returnUrl,
        [constants_1.OPENID_ASSOC_HANDLE_PARAM]: marketplaceOpenidAssocHandle
    };
    const allParams = Object.assign(Object.assign(Object.assign({}, commonAuthPortalParams), additionalParameters), params.additionalQueryParams);
    const buildQueryString = () => {
        const queryParameters = [];
        Object.keys(allParams).forEach((key) => queryParameters.push(`${key}=${encodeURIComponent(allParams[key])}`));
        return queryParameters.join('&');
    };
    const authPortalUrlString = `${retailDomain}${pagePath}?${buildQueryString()}`;
    const SIGN_IN_PATH = '/ap/signin';
    const metricCallerSuffix = authPortalUrlString.includes(SIGN_IN_PATH) ? 'SignIn' : 'Registration';
    const successMetric = 'AUTH_PORTAL_URL_VALID:' + metricCallerSuffix;
    const errorMetric = 'AUTH_PORTAL_URL_INVALID:' + metricCallerSuffix;
    const methodName = 'BuildAuthPortalUrl';
    const emitCountMetrics = require('../metric-helper').emitCountMetrics;
    let authPortalUrl;
    server_1.serverConsole.log(`Attempting to build URL from ${authPortalUrlString}`);
    try {
        authPortalUrl = new URL(authPortalUrlString);
        emitCountMetrics(methodName, successMetric, 1, '', tenant);
        emitCountMetrics(methodName, errorMetric, 0, '', tenant);
    }
    catch (e) {
        const caller = authPortalUrlString.includes(SIGN_IN_PATH) ? 'Sign In' : 'Registration';
        emitCountMetrics(methodName, successMetric, 0, '', tenant);
        emitCountMetrics(methodName, errorMetric, 1, '', tenant);
        throw new Error(`Invalid URL was given to ${caller} url builder in country=${params.countryCode}`);
    }
    return authPortalUrl;
};
const buildSignInUrl = (params) => {
    const { maxAuthAge = 0 } = params;
    const additionalParameters = {
        [constants_1.OPENID_MAX_AUTH_AGE_PARAM]: maxAuthAge.toString()
    };
    const SIGN_IN_PATH = '/ap/signin';
    return buildAuthPortalUrl(params, SIGN_IN_PATH, additionalParameters);
};
exports.buildSignInUrl = buildSignInUrl;
const buildRegistrationUrl = (params) => {
    var _a;
    const REGISTER_PATH = '/ap/register';
    const additionalParameters = (_a = params.additionalQueryParams) !== null && _a !== void 0 ? _a : {};
    return buildAuthPortalUrl(params, REGISTER_PATH, additionalParameters);
};
exports.buildRegistrationUrl = buildRegistrationUrl;
